<div class="container-info slide-bottom">
  <div class="button-container">
    <a class="back-btn" (click)="back()">
      <mat-icon>chevron_left</mat-icon>
      Voltar
    </a>
    @if (isMenu && state != stateEnum.registered && state != stateEnum.uninitiated) {
      <a color="accent" class="delete-btn" (click)="confirmDeleteSignature()">
        <mat-icon>delete</mat-icon>
        Reiniciar
      </a>
    }
  </div>
  <div class="provider-info">
    <img src="/assets/images/signature-providers/safe-id/safeid-logo.png">
    <span>{{title}}</span>
    <span [innerHTML]="description"></span>
  </div>
  @if (ready && formMetaData != null && !isLoading) {
    <form appFormScroll class="form" [formGroup]="model"
      (ngSubmit)="submit()">
      @for (item of model.controls | keyvalue : keyDescOrder; track item) {
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>{{formMetaData[item.key].label}}</mat-label>
            @if (formMetaData[item.key].hideable) {
              <mat-icon matSuffix
                (click)="toggleVisibility(item.key)">{{formMetaData[item.key].hide ?
                'visibility' :
              'visibility_off'}}</mat-icon>
            }
            <input #input matInput type="{{formMetaData[item.key].hide ? 'password' : 'text'}}"
              [mask]="formMetaData[item.key].mask" formControlName="{{item.key}}">
            </mat-form-field>
          </div>
        }
        @if (state != stateEnum.signable && state != stateEnum.uninitiated) {
          <button mat-flat-button type="submit" color="primary"
          class="btn-block">Confirmar</button>
        }
      </form>
    }
    @if (isLoading) {
      <app-loading-progress-bar></app-loading-progress-bar>
    }
  </div>